import {IRawRestrictionType} from "../raw-restriction-types.interface";
import {Check} from "@sparkware/app-utils";

export function computeRestrictionsExpirationDate(rawRestrictions: IRawRestrictionType[]) {
    for (let restrictionType of rawRestrictions) {
        for (let entity of restrictionType.Entities) {
            for (let value of entity.Values) {
                if (Check.isUndefined(value.ComputedExpirationDate)) {
                    if (value.ExpirationDate) {
                        const date = new Date(value.ExpirationDate);
                        value.ComputedExpirationDate = date.getTime() - date.getTimezoneOffset() * 60 * 1000;
                    } else if (!Check.isNullOrUndefined(value.SecondsToExpire)) {
                        value.ComputedExpirationDate = Date.now() + value.SecondsToExpire * 1000;
                    } else {
                        value.ComputedExpirationDate = null;
                    }
                }
            }
        }
    }
}